var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInpersionicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8001 10.5C5.43662 10.5 6.04707 10.2471 6.49715 9.79706C6.94724 9.34697 7.2001 8.73652 7.2001 8.1C7.2001 7.46348 6.94724 6.85303 6.49715 6.40294C6.04707 5.95286 5.43662 5.7 4.8001 5.7C4.16358 5.7 3.55313 5.95286 3.10304 6.40294C2.65295 6.85303 2.4001 7.46348 2.4001 8.1C2.4001 8.73652 2.65295 9.34697 3.10304 9.79706C3.55313 10.2471 4.16358 10.5 4.8001 10.5ZM9.0001 16.8V15.3C9.0001 12.9 6.6226 11.4 4.8001 11.4C2.9776 11.4 0.600098 12.9 0.600098 15.3V16.8H9.0001ZM15.9001 1.5H8.4001C8.08184 1.5 7.77661 1.62643 7.55157 1.85147C7.32653 2.07652 7.2001 2.38174 7.2001 2.7V5.4222C7.9348 6.081 8.4001 7.035 8.4001 8.1C8.4001 8.6184 8.2882 9.1095 8.0914 9.555C8.1904 9.5814 8.293 9.6 8.4001 9.6H10.8001V10.6395C10.8001 10.7229 10.8227 10.8047 10.8656 10.8762C10.9084 10.9477 10.9699 11.0063 11.0434 11.0456C11.1169 11.0849 11.1997 11.1036 11.283 11.0995C11.3662 11.0955 11.4468 11.0689 11.5162 11.0226L13.6501 9.6H15.9001C16.2184 9.6 16.5236 9.47357 16.7486 9.24853C16.9737 9.02348 17.1001 8.71826 17.1001 8.4V2.7C17.1001 2.38174 16.9737 2.07652 16.7486 1.85147C16.5236 1.62643 16.2184 1.5 15.9001 1.5Z",
    fill: "#00BD7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInpersionicon);
export default __webpack_public_path__ + "static/media/inpersionicon.511c03bee0f5c34b48dcc445308ca24a.svg";
export { ForwardRef as ReactComponent };